import { DefaultDetails, TypedStatusUpdateMessage } from "@status-updates/types";
import Typography from "@anwb/typography";
import { DateTime } from "luxon";
import { FrontendState, StateMetadata } from "../frontend-state";
import { MeldingAnnuleren } from "./melding-annuleren";

export class WegenwachtScheduleChanged extends FrontendState<DefaultDetails> {
  constructor(message: TypedStatusUpdateMessage<DefaultDetails>, metadata: StateMetadata) {
    super(message, metadata, {
      illustration: "alarmcentrale",
      title: "Planning aangepast",
    });
  }

  renderTimelineItems() {
    return [
      {
        timestamp: DateTime.fromISO(this.message.created),
        title: this.options.title,
        content: (
          <Typography
            data-e2e-test-type="status-updates-wegenwacht-schedule-changed-message"
            tagName="div"
          >
            <p>
              Sorry, we hebben de planning moeten aanpassen. De wegenwacht die onderweg was naar{" "}
              {this.getInformalOrFormal("jou", "u")} moest plotseling naar een andere melding. We sturen zo snel mogelijk een andere wegenwacht.
              <br />
              <br />
              Zodra er meer nieuws is, {this.getInformalOrFormal("krijg je", "krijgt u")} een nieuwe
              update. Dit kan even duren.
            </p>
            {this.metadata.showDigitalCancelButton && (
              <MeldingAnnuleren
                contractMarket={this.metadata.contractMarket}
                assistancePhonenumber={this.metadata.assistancePhonenumber}
              />
            )}
          </Typography>
        ),
        feedback: this.renderFeedback(),
      },
    ];
  }
}
